var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncludedTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.149,
    height: 34.149,
    viewBox: "0 0 34.149 34.149",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ticket",
    transform: "translate(0.318 8.902) rotate(-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36449",
    "data-name": "Path 36449",
    d: "M25.883,158.058A4.121,4.121,0,0,0,22.247,152H4.12a4.121,4.121,0,0,0-3.636,6.058l1.456,2.728a1.032,1.032,0,0,1,0,.967L.484,164.481a4.121,4.121,0,0,0,3.636,6.058H22.247a4.121,4.121,0,0,0,3.636-6.058l-1.456-2.728a1.031,1.031,0,0,1,0-.967Zm-1.817-.97-1.456,2.728a3.094,3.094,0,0,0,0,2.907l1.456,2.728a2.033,2.033,0,0,1,.241.968,2.062,2.062,0,0,1-2.06,2.06H4.12a2.062,2.062,0,0,1-2.06-2.06,2.033,2.033,0,0,1,.241-.968l1.456-2.728a3.1,3.1,0,0,0,0-2.907L2.3,157.088a2.033,2.033,0,0,1-.241-.968,2.062,2.062,0,0,1,2.06-2.06H22.247a2.062,2.062,0,0,1,2.06,2.06A2.033,2.033,0,0,1,24.065,157.088Z",
    transform: "translate(0 -144.173)",
    fill: "#23262f",
    stroke: "#23262f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1674",
    "data-name": "Ellipse 1674",
    cx: 0.943,
    cy: 0.943,
    r: 0.943,
    transform: "translate(6.571 12.227)",
    fill: "#23262f",
    stroke: "#23262f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1675",
    "data-name": "Ellipse 1675",
    cx: 0.943,
    cy: 0.943,
    r: 0.943,
    transform: "translate(6.571 15.997)",
    fill: "#23262f",
    stroke: "#23262f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1676",
    "data-name": "Ellipse 1676",
    cx: 0.943,
    cy: 1.414,
    rx: 0.943,
    ry: 1.414,
    transform: "translate(6.571 19.768)",
    fill: "#23262f",
    stroke: "#23262f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36450",
    "data-name": "Path 36450",
    d: "M.533,6.15A1.03,1.03,0,1,0,2.35,5.18L2.3,5.088A2.032,2.032,0,0,1,2.06,4.12,2.062,2.062,0,0,1,4.12,2.06H22.247a2.062,2.062,0,0,1,2.06,2.06,2.034,2.034,0,0,1-.241.968l-.05.093a1.03,1.03,0,1,0,1.817.97l.05-.093A4.121,4.121,0,0,0,22.247,0H4.12A4.121,4.121,0,0,0,.484,6.058Z",
    transform: "translate(0)",
    fill: "#23262f",
    stroke: "#23262f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36451",
    "data-name": "Path 36451",
    d: "M357.03,232a1.03,1.03,0,0,0-1.03,1.03v8.239a1.03,1.03,0,1,0,2.06,0V233.03A1.03,1.03,0,0,0,357.03,232Z",
    transform: "translate(-337.667 -220.053)",
    fill: "#23262f",
    stroke: "#23262f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36452",
    "data-name": "Path 36452",
    d: "M277.03,232a1.03,1.03,0,0,0-1.03,1.03v8.239a1.03,1.03,0,1,0,2.06,0V233.03A1.03,1.03,0,0,0,277.03,232Z",
    transform: "translate(-261.787 -220.053)",
    fill: "#23262f",
    stroke: "#23262f",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncludedTicket);
export default __webpack_public_path__ + "static/media/includedTicket.dcc4c9e4db4410d26bf18755bf4bb892.svg";
export { ForwardRef as ReactComponent };